<template>
    <div class="validate-content" :class="{'bodyfont-unauth': !user}">
        <div class="col-md-12 bg-white">
            <div class="main-content emailrules">
                <h2 class="heading">
                    Too many Emails? Let's change that!
                </h2>
                <h2>Email Preferences</h2>
                <checkbox class="margin-left" v-model="userObj.isOptOutTeaser" :value="userObj.isOptOutTeaser"><span class="checkboxcontent"><span><strong>Unsubscribe from TONE Teasers</strong></span><span class="smpreferences"><small>&nbsp;Twice a week email with videos selected specifically for you</small></span></span>
                </checkbox>
                <checkbox class="margin-left" v-model="userObj.isOptOutTakeaways" :value="userObj.isOptOutTakeaways" ><span class="checkboxcontent"><span><strong>Unsubscribe from TONE Takeaways</strong></span><span class="smpreferences"><small>&nbsp;Follow up email with key lessons once you have watched a video</small></span></span>
                </checkbox>
                <checkbox class="margin-left" v-model="userObj.isOptOutContentEmail" :value="userObj.isOptOutContentEmail" ><span  class="checkboxcontent"><span><strong>Unsubscribe from Content Emails</strong></span><span  class="smpreferences"><small>&nbsp;Event reminders, calendar invites, series launches and video blogs</small></span></span>
                </checkbox>
                <div class="center">
                <button class="btn formButton btn-block" @click="updatePrefrences()" :disabled="spinner">
                    Update Preferences
                    <spinner v-model="spinner" size="lg" class="btn-spinner"></spinner>
                </button>
            </div>
            </div>
                <!--<button class="btn formButton btn-block" type="submit" id="signup_button" :disabled="isUserLoggedIn">-->

        </div>
<!--        <div v-if="validationSuccess">-->
<!--            <strong>Thank You! Your Account has been validated</strong>-->
<!--            <h3 class="redirectMsg" v-if="!user">Log In to TONE Networks!</h3>-->
<!--            <div class="clearfix"></div>-->
<!--            <h3 class="text-center">-->
<!--                <i class="fa fa-chevron-right "></i><i class="fa fa-chevron-right "></i><i class="fa fa-chevron-right "></i>-->
<!--                Redirecting now-->
<!--                <i class="fa fa-chevron-right "></i><i class="fa fa-chevron-right "></i><i class="fa fa-chevron-right "></i>-->
<!--            </h3>-->
<!--        </div>-->

        <!--<alert v-model="validationSuccess" placement="top-right" duration="2000" type="success" width="400px" dismissable>-->
            <!--<span class="icon-info-circled alert-icon-float-left"></span>-->
            <!--<strong>Thank You! Your Account has been validated</strong>-->
            <!--<p id="validation_successmsg">Now login to Tone Networks to watch our awesome videos</p>-->
        <!--</alert>-->
        <!--<div class="form">-->
            <!--<form v-on:submit.prevent="onSubmit">-->
                <!--<div class="validateField">-->
                    <!--<bs-input v-model="user.email"-->
                              <!--id = "validate_email"-->
                              <!--type="email"-->
                              <!--class="form-input"-->
                              <!--error="Email is Required"-->
                              <!--placeholder="Email Address"-->
                              <!--required-->
                              <!--icon>-->
                    <!--</bs-input>-->
                    <!--<bs-input v-model="user.validationCode"-->
                              <!--id = "validate_validationcode"-->
                              <!--type="text"-->
                              <!--class="form-input"-->
                              <!--error="Code is Required"-->
                              <!--placeholder="Validation Code"-->
                              <!--required-->
                              <!--icon>-->
                    <!--</bs-input>-->
                <!--</div>-->
                <!--<div>-->
                    <!--<button class="btn formButton" id="validate_button">-->
                        <!--Submit-->
                        <!--&lt;!&ndash;<spinner v-model="spinner" size="lg" class="btn-spinner"></spinner>&ndash;&gt;-->
                    <!--</button>-->
                <!--</div>-->
            <!--</form>-->
            <!--<alert v-model="error.show" placement="top-right" duration="2000" type="danger" width="400px" dismissable>-->
                <!--<span class="icon-info-circled alert-icon-float-left"></span>-->
                <!--<strong>Error:</strong>-->
                <!--<p id="login_errormsg">{{error.message}}</p>-->
            <!--</alert>-->
        <!--</div>-->
    </div>
</template>

<script>
import { carousel, slider } from 'vue-strap'
import alert from '@/accessibility/Alert'
import spinner from '@/accessibility/Spinner'
import input from '@/accessibility/Input'
import checkbox from '@/accessibility/Checkbox'
import { mapGetters } from 'vuex'
// import store from '../store'
// var crypto = require('crypto')

export default {
    components: {
        'bs-input': input,
        alert,
        spinner,
        checkbox,
        carousel,
        slider
    },
    name: 'emailRules',
    data: function () {
        return {
            userObj: {
                userId: 0,
                isOptOutTeaser: false,
                isOptOutTakeaways: false,
                isOptOutContentEmail: false
            },
            spinner: false,
            paramEmail: '',
            paramValidationCode: '',
            validationSuccess: false,
            teaserRule: false,
            takeawayRule: false,
            userId: ''
        }
    },
    computed: {
        ...mapGetters([
            'error', 'user', 'getValidationStatusError', 'getUserEmailPreferences'
        ])
    },
    methods: {
        spinnerToggle () {
            this.spinner = !this.spinner
        },
        updatePrefrences () {
            let self = this
            self.spinnerToggle()
            let finalObj = {
                userId: self.userObj.userId,
                isOptOutTeaser: self.userObj.isOptOutTeaser ? 1 : 0,
                isOptOutTakeaways: self.userObj.isOptOutTakeaways ? 1 : 0,
                isOptOutContentEmail: self.userObj.isOptOutContentEmail ? 1 : 0
            }
            this.$store.dispatch('UPDATE_USER_PREFERENCES', {user: finalObj}).then(() => {
                //  this.spinnerToggle()
                if (!this.error.show) {
                    this.spinnerToggle()
                    self.$swal({
                        title: 'Thank you!',
                        text: 'Your email preferences have been updated',
                        type: 'success',
                        timer: 3000,
                        showCancelButton: false,
                        showConfirmButton: false
                    }).then(
                        function () {
                        },
                        // handling the promise rejection
                        function (dismiss) {
                            if (dismiss === 'timer') {
                            }
                        }
                    )
                    self.$router.push('/')
                } else {
                    this.spinnerToggle()
                }
            })
        },
        onSubmit: function () {
            if (this.user) {
                // this.spinnerToggle()
                this.$store.dispatch('VALIDATE', {user: this.user}).then(() => {
                   //  this.spinnerToggle()
                    if (!this.error.show) {
                        this.validationSuccess = true
                        setTimeout(() => {
                            this.validationSuccess = false
                            this.$router.push('/')
                        }, 4000)
                    }
                })
            }
        }
    },
    mounted: function () {
        let self = this
        self.userId = self.$route.query.params
        if (self.$route.query.params) {
            self.userObj.userId = self.userId
            self.$store.dispatch('GET_USER_EMAIL_PREFRENCES', self.userId).then(() => {
                if (self.getUserEmailPreferences) {
                    if (self.getUserEmailPreferences.isOptOutTeaser === 1) {
                        self.userObj.isOptOutTeaser = true
                    }
                    if (self.getUserEmailPreferences.isOptOutTakeaways === 1) {
                        self.userObj.isOptOutTakeaways = true
                    }
                    if (self.getUserEmailPreferences.isOptOutContentEmail === 1) {
                        self.userObj.isOptOutContentEmail = true
                    }
                    // self.userObj.isOptOutTeaser = self.getUserEmailPreferences.isOptOutTeaser === 1 ? true: false
                    // self.userObj.isOptOutTakeaways = self.getUserEmailPreferences.isOptOutTakeaways === 1 ? true: false
                } else {
                    // User Reference not found based on provided link
                    self.$swal({
                        title: 'User Reference not found',
                        text: '',
                        type: 'error',
                        timer: 3000,
                        showCancelButton: false,
                        showConfirmButton: false
                    }).then(
                        function () {
                        },
                        // handling the promise rejection
                        function (dismiss) {
                            if (dismiss === 'timer') {
                            }
                        }
                    )
                    self.$router.push('/')
                }
            })
        } else {
            // query string not provided
            self.$router.push('/')
        }
    }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->


<style scoped>

    .center {
    }
    .margin-left {
        margin-left: 30px;
    }
    .bg-white {
        background-color: white;
    }
    .checkboxcontent {
        display: flex;
        flex-direction: column;
    }
    .checkboxcontent strong {
        font-weight: 600 !important;
    }
    .smpreferences {
        padding-left: 50px;
    }
    .smpreferences small {
        font-weight: 500 !important;
    }
    .validate .form{
        text-align: left;
        width: 40%;
        margin: 50px auto;
    }
    h2.heading {
        color: #f0617d;
        text-transform: capitalize;
        margin: 47px 0 35px 0;
        letter-spacing: 0.5px;
        font-family: sans-serif;
        font-size: 30px;
    }
    .validate h1{
        font-size: 32px;
        color: #009cf6;
        font-weight: lighter;
        margin: 0 0 25px 0;
    }
    .validate p{
        font-size: 14px;
        color: #979797;
        margin: 0;
    }
    .padding-minus{
        padding:0;
    }
    .validate .form .form-input{
        margin-bottom: 25px ;
    }
    .validate .form .forgotPassword{
        float: right;
        color: black
    }
    .validate .form .forgotPassword:hover{
        float: right;
        color: #337ab7;
    }
    .formButton{
        margin: 25px 0 50px;
        width: 130px;
        height: 47px;
        color: black !important;
        border: 1px solid black !important;
        background-color: #ddd !important;
        font-size: 22px !important;
        font-weight: 600px !important;
        margin-top: 44px !important;
        margin-bottom: 40px !important;
        max-width: 263px !important;
        margin: 25px auto !important;
        transition: 0.5s;
        padding:14px 20px !important;
    }
    button.btn.formButton.btn-block:hover {
        background: #f0617d !important;
        color: white !important;
    }
    .formButton a{
        display: block;
        padding: 13px 12px;
        color: #91ab45;
        text-decoration: none;
        transition: 0.5s;
    }
    .formButton:hover{
        border-color: #91ab45;
        background-color: #91ab45;
        transition: 0.5s;
        color: #ffffff;
    }
    .btn-spinner{
        bottom:15px
    }
</style>

<style>
    .main-content.emailrules {
        max-width: 767px;
        margin: auto;
    }

    .main-content.emailrules label.open.checkbox.default {
        font-size: 24px;
        text-align: left;
        padding-left: 30px;
    }
	
    .main-content.emailrules 	label.checkbox > span.icon.dropdown-toggle.bg {
        margin-top: 4px;
        width: 2rem;
        height: 2rem;
        background: white;
        border: 2px solid #ddd; 
    }

    .main-content.emailrules label.checkbox.active > .icon {
        margin-top: 7px;
        background-position: center !important;
        width: 20px;
    }

strong {}

    .main-content.emailrules button.btn.formButton.btn-block {
border-radius: 8px;
max-width: 200px;
margin: 30px;
}

    .main-content.emailrules h2.heading + h2 {
text-align: left;
padding: 10px 30px;
}
</style>



// WEBPACK FOOTER //
// EmailRules.vue?547e7112